'use client';
import { useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAccount } from '@/frontastic';
import { formatAmount, formatDateMoment, getStatusLabel } from '@/helpers/utils/siteUtils';
import { RefundHistoryPayload } from '@/sdk/composable-commerce/types/payloads/AccountPayloads';
import { DATE_FORMAT } from '../../../../../../constants/constant';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/customAccordian/customAccordian';
import { Table, TableColumnConfig } from '../../../ui/customTable/Table';
import Loader from '../../../ui/loader';
import Pagination from '../../../utils/pagination';
import {
  PAYLOAD_QUERY,
  REFUND_CHECK_HISTORY,
  REFUND_CHECK_HISTORY_HEADER,
  REFUND_CHECK_HISTORY_KEYS,
  REFUND_HISTORY_PER_PAGE,
  RESPONSE_SUCCESS_MESSAGE,
} from '../../constants';
import { RefundHistory } from '../../types';
const CustomerRefundCheckHistory = ({ Texts }: any) => {
  const [tableData, setTableData] = useState<RefundHistory[]>([]);
  const [totalHistory, setTotalHistory] = useState(0);
  const [loading, setLoading] = useState(false);
  const { getCustomerRefundCheckHistory } = useAccount();
  const [currentPage, setCurrentPage] = useState(1);
  const params = useSearchParams();
  const tableHeaders: TableColumnConfig<any>[] = [
    {
      key: REFUND_CHECK_HISTORY_KEYS.DATE_SENT,
      header: REFUND_CHECK_HISTORY_HEADER.DATE_SENT,
      render: (data) => <div>{formatDateMoment(data, DATE_FORMAT)}</div>,
    },
    {
      key: REFUND_CHECK_HISTORY_KEYS.CHECK_NUMBER,
      header: REFUND_CHECK_HISTORY_HEADER.CHECK_NUMBER,
      render: (data: any) => <div className="gbmask">{data}</div>,
    },
    {
      key: REFUND_CHECK_HISTORY_KEYS.CHECK_AMOUNT,
      header: REFUND_CHECK_HISTORY_HEADER.CHECK_AMOUNT,
      render: (data) => <div>{formatAmount(data ?? '')}</div>,
    },
    {
      key: REFUND_CHECK_HISTORY_KEYS.STATUS,
      header: REFUND_CHECK_HISTORY_HEADER.STATUS,
      render: (data) => <div>{getStatusLabel(data ?? '')}</div>,
    },
    {
      key: REFUND_CHECK_HISTORY_KEYS.CLOSED_DATE,
      header: REFUND_CHECK_HISTORY_HEADER.CLOSED_DATE,
      render: (data) => <div>{formatDateMoment(data, DATE_FORMAT)}</div>,
    },
  ];
  const getRefundCheckHistory = async (pageNumber?: number) => {
    setLoading(true);
    if (PAYLOAD_QUERY.OMS_CUSTOMER_ID && PAYLOAD_QUERY.DIVISION_CODE) {
      const payload = {
        omsCustomerId: params.get(PAYLOAD_QUERY.OMS_CUSTOMER_ID),
        divisionCode: params.get(PAYLOAD_QUERY.DIVISION_CODE),
        pageNumber: pageNumber ?? currentPage,
        pageSize: REFUND_HISTORY_PER_PAGE,
      } as RefundHistoryPayload;
      await getCustomerRefundCheckHistory(payload)
        .then((res) => {
          if (res?.code === RESPONSE_SUCCESS_MESSAGE) {
            setTableData(res?.RefundChecks);
            setTotalHistory(res?.quantity);
          }
        })
        .catch(() => setLoading(false));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const onPageChange = async (page: number) => {
    setCurrentPage(page);
    await getRefundCheckHistory(page);
  };
  return (
    <Accordion
      type="single"
      collapsible
      className="w-full rounded-md border border-foggyGray px-5 py-1 shadow-lg"
      onValueChange={(value) => {
        if (value === REFUND_CHECK_HISTORY) {
          getRefundCheckHistory();
        }
      }}
    >
      {loading && <Loader />}
      <AccordionItem value={REFUND_CHECK_HISTORY} className="border-none">
        <AccordionTrigger className="text-lg font-bold hover:no-underline">{Texts.refundCheckHistory}</AccordionTrigger>
        <AccordionContent className="pb-5">
          <Table columns={tableHeaders} data={tableData} />
          <div>{!tableData?.length ? Texts.noRecordsFound : ''}</div>
          {totalHistory > 5 && (
            <section className="mt-4 flex justify-end">
              <Pagination
                currentPage={currentPage}
                itemsPerPage={REFUND_HISTORY_PER_PAGE}
                totalItems={totalHistory}
                onPageChange={onPageChange}
              ></Pagination>
            </section>
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default CustomerRefundCheckHistory;
